<template>
    <v-row>
        <v-col cols="3">
            <v-treeview
                v-model="tree"
                :active.sync="selection"
                :items="devicesTree"
                activatable
            >
                <template v-slot:prepend="{ item, open }">
                    <v-icon v-if="!item.type" :color="iconColor(open)">
                        {{ 'mdi-desktop-classic' }}
                    </v-icon>
                    <v-icon v-else>
                        {{ 'mdi-overscan' }}
                    </v-icon>
                </template>
            </v-treeview>
        </v-col>
        <v-divider vertical></v-divider>
        <v-scroll-y-transition mode="out-in">
            <div v-if="formType == ''">
                
            </div>
            <v-col cols="8" v-else-if="formType == 'device'">
                <v-card outlined class="mx-auto" max-width="600">
                    <v-card-subtitle>
                        Dispositivo {{updateDevice.name}}
                    </v-card-subtitle>
                    <v-card-actions>
                    <v-row>
                            <v-col cols="12" sm="12">
                                <v-text-field
                                    v-model="updateDevice.name"
                                    outlined
                                    dense
                                    label="Nombre"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" v-show="hasImagen">
                                <v-card>
                                    <v-img
                                        :src="imageUrl"
                                        max-height="125"
                                        max-width="580"
                                        contain
                                        class="white"
                                    ></v-img>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-file-input
                                    label="Imagen"
                                    prepend-icon="mdi-camera"
                                    outlined
                                    dense
                                    show-size
                                    accept="image/*"
                                    v-model="fileImage"
                                    @change="uploadImage"
                                ></v-file-input>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-badge
                                    bordered
                                    :color="deviceColor"
                                    overlap
                                >
                                    <v-text-field
                                        v-model="deviceColor"
                                        outlined
                                        dense
                                        label="Color"
                                        readonly
                                        @click="viewColorSelector()"
                                    >
                                    </v-text-field>
                                </v-badge>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field
                                    v-model.number="displayRank"
                                    outlined
                                    dense
                                    :rules="[rules.min, rules.max]"
                                    type="number"
                                    label="Prioridad"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12">
                                <v-text-field
                                    v-model="updateDevice.info.description"
                                    outlined
                                    dense
                                    label="Descripcion"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateDevice.address.ip"
                                    outlined
                                    dense
                                    label="Direccion IP"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateDevice.address.mac"
                                    outlined
                                    dense
                                    label="Direccion MAC"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model.number="updateDevice.location.lat"
                                    outlined
                                    dense
                                    type="number"
                                    label="Localización Latitud"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model.number="updateDevice.location.lng"
                                    outlined
                                    dense
                                    type="number"
                                    label="Localización Longitud"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateDevice.laeqFilter.max"
                                    outlined
                                    dense
                                    label="Filtro Laeq Maximo"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateDevice.laeqFilter.min"
                                    outlined
                                    dense
                                    label="Filtro Laeq Minimo"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" class="text-right">
                                <v-btn
                                    outlined
                                    color="green"
                                    dark
                                    @click="updateData"
                                >
                                    Actualizar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="8" v-else>
                <v-card outlined class="mx-auto" max-width="600">
                    <v-card-subtitle>
                        Dispositivo {{sensorDeviceName}} / Sensor {{updateSensor.sensorName}}
                    </v-card-subtitle>
                    <v-card-actions>
                    <v-row>
                            <v-col cols="12" sm="12">
                                <v-switch
                                    v-model="updateSensor.viewUser"
                                    :label="viewUserLabel"
                                    color="success"
                                    hide-details
                                    inset
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.sensorName"
                                    outlined
                                    dense
                                    readonly
                                    label="Nombre"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.sensorType"
                                    outlined
                                    dense
                                    readonly
                                    label="Tipo"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.description"
                                    outlined
                                    dense
                                    label="Descripcion"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.unit"
                                    outlined
                                    dense
                                    label="Unidad de medida"
                                    hint="Ej, [m]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12">
                                <v-switch
                                    v-model="updateSensor.hasEvents"
                                    :label="hasEventLabel"
                                    color="success"
                                    hide-details
                                    inset
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.highThreshold"
                                    outlined
                                    dense
                                    clearable
                                    :disabled="!updateSensor.hasEvents"
                                    type="number"
                                    label="Umbral Maximo"
                                    hint="Umbral en que se activa el evento"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.lowThreshold"
                                    outlined
                                    dense
                                    clearable
                                    :disabled="!updateSensor.hasEvents"
                                    type="number"
                                    label="Umbral Minimo"
                                    hint="Umbral en que se activa el evento"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.offset"
                                    outlined
                                    dense
                                    clearable
                                    type="number"
                                    label="Offset"
                                    hint="Agregar un offset a los datos sensados"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" class="text-right">
                                <v-btn
                                    outlined
                                    color="green"
                                    @click="updateData"
                                    dark
                                >
                                    Actualizar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-scroll-y-transition>
        <v-row>
            <v-dialog v-model="loadingUpdateImage" hide-overlay persistent width="300">
                <v-card color="green" dark>
                    <v-card-text>
                        Subiendo Imagen
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog
                v-model="colorSelector"
                width="300"
            >
                <v-card>
                    <v-card-title>
						<span class="text-h5">Seleccionar color</span>
					</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-color-picker
                                    v-model="selectColor"
                                    mode.sync="hex"
                                    flat
                                ></v-color-picker>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
   
                        <v-btn
                            color="primary"
                            @click="cancelColor()"
                        >
                            Cancelar
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="setColor()"
                        >
                            Aceptar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-row>
</template>

<script>
    import axios from 'axios'
    import authHeader from '../../services/authHeader';

  export default {
    name: 'DevicesConfig',

    data: () => ({
        devicesTree: [],
        formType: '',
        updateDevice: {
            address: {
                ip: '',
                mac: ''
            },
            location: {
                lat: 0,
                lng: 0
            },
            info: {
                description: '',
                image: ''
            },
            deviceImage: null
        },
        updateSensor: {},
        color: 'primary',
        files: {
            html: 'mdi-language-html5',
            js: 'mdi-nodejs',
            json: 'mdi-code-json',
            md: 'mdi-language-markdown',
            pdf: 'mdi-file-pdf',
            png: 'mdi-file-image',
            txt: 'mdi-file-document-outline',
            xls: 'mdi-file-excel',
        },
        tree: [],
        selection: [],
        fileImage: null,
        loadingUpdateImage: false,
        colorSelector: false,
        imageUrl: '',
        selectColor: '',
        deviceColor: '',
        displayRank: 1,
        rules: {
            min: v => v >= 1 || 'Valor minimo 1',
            max: v => v <= 10 || 'Valor maximo 10',
        },
    }),

    computed: {
        devices () {
            return this.$store.getters.devices
        },

        sensors () {
            return this.$store.getters.allSensors
        },

        sensorDeviceName () {
            return this.devices.find( e => {
                return e.deviceId === this.updateSensor.deviceId
            }).name
        },

        viewUserLabel () {
            return this.updateSensor.viewUser ? 'Sensor visible para todos' : 'Sensor visible solo administracion'
        },

        hasEventLabel () {
            return this.updateSensor.hasEvents ? 'Eventos activados' : 'Eventos desactivados'
        },

        uriServer() {
            return this.$store.getters.uri
        },

        hasImagen () {
            return this.imageUrl.length > 0
        }
    },

    methods: {
        iconColor (isOpen) {
            return isOpen ? 'primary' : ''
        },

        createDeviceTree (sensor) {
            let items = []
            let children = {}

            for (let i = 0; i < sensor.length; i++) {
                const element = sensor[i]

                if (!Object.hasOwnProperty.call(children, element.deviceId))
                    children[element.deviceId] = []

                children[element.deviceId].push({
                    id: element._id,
                    name: element.sensorName,
                    type: element.sensorType
                })
            }
            
            for (const key in children) {
                if (Object.hasOwnProperty.call(children, key)) {
                    const element = children[key]
                    const device = this.devices.find( e => e.deviceId === key)
                    
                    items.push({
                        id: device._id,
                        name: device.name,
                        children: element
                    })
                }
            }

            this.devicesTree = items
        },

        selectType (id) {
            const findDevice = this.devices.filter( e => {
                return e._id === id[0]
            })
            
            if (findDevice.length > 0) {
                this.formType = 'device'
                this.updateDevice = findDevice[0]

                if (!Object.hasOwnProperty.call(this.updateDevice, "laeqFilter")) {
                    this.updateDevice.laeqFilter = {
                        max: 90,
                        min: 45
                    }
                }
                
                if (!Object.hasOwnProperty.call(this.updateDevice, "location")) {
                    this.updateDevice.location = {
                        lat: 0,
                        lng: 0
                    }
                }

                if (!Object.hasOwnProperty.call(this.updateDevice, "info")) {
                    this.updateDevice.info = {
                        description: '',
                        image: ''
                    }
                }
            }

            const { info } = this.updateDevice

            this.fileImage = null
            this.deviceColor = info.color ? info.color : '#FFFFFF'
            this.displayRank = info.displayRank ? info.displayRank : 1
            this.imageUrl = info.image

            const findSensor = this.sensors.filter( e => {
                return e._id === id[0]
            })

            if (findSensor.length > 0) {
                this.formType = 'sensor'
                this.updateSensor = findSensor[0]
            }
        },

        updateData () {
            if (this.formType === 'device') {
                this.$store.dispatch('updateDevice', this.updateDevice)
            }

            if (this.formType === 'sensor') {
                this.$store.dispatch('updateSensor', this.updateSensor)
            }
        },

        uploadImage() {
            if (!this.fileImage)
                return

            const formData = new FormData()
            formData.append('image', this.fileImage)

            const url = `${this.uriServer}/device/${this.updateDevice.deviceId}/image`
            
            this.loadingUpdateImage = true
            axios
            .post(url, formData, { headers: {...authHeader(), 'Content-Type': 'multipart/form-data' } })
            .then(response => {
                this.imageUrl = response.data.imageUrl
                this.updateDevice.info.image = response.data.imageUrl
            })
            .catch(error => {
                this.$store.dispatch('errorNotification', { msg: 'No se pudo guardar imagen', error: error })
                console.log(error)
            })
            .finally(() => {
                this.loadingUpdateImage = false
            })
        },

        viewColorSelector() {
            this.colorSelector = true
            this.selectColor = this.deviceColor
        },

        setColor () {
            this.deviceColor = this.selectColor
            this.colorSelector = false
            this.updateDevice.info.color = this.selectColor
        },

        cancelColor () {
            this.colorSelector = false
        }
    },

    watch: {
        selection (newValue) {
            this.selectType(newValue)
        },

        sensors (val) {
            this.createDeviceTree(val)

            if ( this.devicesTree.length > 0 )
                this.selection = [this.devicesTree[0].id]
        },
            

        displayRank (val) {
            if ( val < 1 )
                this.displayRank = 1

            if ( val > 10)
                this.displayRank = 10
                
            this.updateDevice.info.displayRank = this.displayRank
        }
        
    },

    created () {
        this.createDeviceTree(this.sensors)
    }
  }
</script>